import VerticalCard from "./components/VerticalCard"
export default VerticalCard
